<div class="db-create-ai-assistant-finalize__steps">
  <h3 class="db-create-ai-assistant-finalize__title">{{'text_generatingYourPersonalizedAiType' | dbText:{singlePage: singlePage ? 'page' : 'website'} }}</h3>
  <ul class="db-create-ai-assistant-finalize__steps-items">
    <li *ngFor="let step of steps; let i = index"
        [ngClass]="{'process': step?.status === 'process','passed': step?.status === 'passed',
        'show-stroke': step.status === 'passed' && steps[i + 1]?.status === 'passed'}">
      <img *ngIf="step?.status === 'todo'; else loader"
         src="assets/images/icons/stroke-loading-whole.svg" />
      <ng-template #loader>
         <span class="step db-icon db-icon-ds-checkmark-circle" *ngIf="step?.status === 'passed'"></span>
         <img class="loader" *ngIf="step?.status === 'process'" src="assets/images/loading/spinner-dotted-new.svg">
      </ng-template>
      <p>
      <span class="db-create-ai-assistant-finalize__step-label ml12">{{step?.label | dbText}}</span>
      <span class="db-create-ai-assistant-finalize__step-desc ml12" *ngIf="step?.status === 'process'">{{step?.description | dbText}}</span>
      </p>
    </li>
  </ul>
</div>
